
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { OrganizationSource } from '@/Sources';

  @Component({
    name: 'organization-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class OrganizationDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Organization' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;

    public source: OrganizationSource = new OrganizationSource();

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }
  }
